import script from "./NavbarMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavbarMain.vue?vue&type=script&setup=true&lang=ts"

import "./NavbarMain.vue?vue&type=style&index=0&id=2dcd199c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dcd199c"]])

export default __exports__